import { Component, inject } from '@angular/core';
import { TreeViewProviderDirective } from '@app/providers';
import { ItemActionResult, ListViewProviderDirective } from '@ntap/core';
import { PrimeNGButtonSaveCloseItemActionComponent } from '@ntap/primeng';

@Component({
  selector: 'app-save-close-izlucivanje-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html',
  styleUrls: ['./save-close-izlucivanje-action.component.scss']
})
export class SaveCloseIzlucivanjeActionComponent extends PrimeNGButtonSaveCloseItemActionComponent {
  private listViewProvider = inject(ListViewProviderDirective, {});

  override updateItem(itemActionResult: ItemActionResult) {
    const viewName = this.listViewProvider.viewName;
    if (
      (!!this.listViewProvider && viewName === 'izlucivanje') ||
      viewName === 'predaja_gradiva' ||
      viewName === 'zaprimanje_gradiva'
    ) {
      super.updateItem(itemActionResult);
    } else if (
      this.listViewProvider &&
      !(this.listViewProvider instanceof TreeViewProviderDirective)
    ) {
      // TODO trebalo bi potegnut selectedItems kao refreshane pa ih updejtat u listi
      this.listViewProvider.refresh();
    } else if (this.listViewProvider instanceof TreeViewProviderDirective) {
      // NE RADI za hiera
    }
  }
}
